import React from 'react'

import {Swiper, SwiperSlide} from "swiper/react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import 'swiper/css/navigation';
import { Autoplay, FreeMode, Navigation, Pagination}  from 'swiper/modules'


import Course_Card from './Course_Card'


const CourseSlider = ({Courses}) => {
  return (
    <>
      {Courses?.length ? (
        <Swiper
          slidesPerView={1}
          spaceBetween={25}
       //freeMode={true} 
          navigation={true}
        //   loop={true}
          modules={[FreeMode,Autoplay, Pagination, Navigation]}
          breakpoints={{
            1024: {
              slidesPerView: 3,
            },
            700:{
              slidesPerView: 2,
            },
            240:{
              slidesPerView: 1,
            }
          }}
          className="max-h-[30rem]"
        >
          {Courses?.map((course, i) => (
            <SwiperSlide key={i}>
              <Course_Card course={course} Height={"lg:h-[250px]"} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <p className="text-xl text-richblack-5">No Course Found</p>
      )}
    </>
  )
}

export default CourseSlider
